export function isBrowserEnvironment() {
    return typeof window !== 'undefined' && typeof window.document !== 'undefined';
}